<div class="tooltip-wrapper">
    <div class="tooltip-title" [innerHTML]="tooltipTitle"></div>
    <div class="tooltip-text">Number of user comments not currently visible</div>
</div>
